import { render } from "./XmlElementName.vue?vue&type=template&id=5a0ac6a5&scoped=true"
import script from "./XmlElementName.vue?vue&type=script&lang=js"
export * from "./XmlElementName.vue?vue&type=script&lang=js"

import "./XmlElementName.vue?vue&type=style&index=0&id=5a0ac6a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0ac6a5"]])

export default __exports__